import dynamic from "next/dynamic";
import { ComponentType } from "react";

type TIllustrationComponent = ComponentType;
type TIllustrationLoader = () => Promise<{ default: TIllustrationComponent }>;

export const getIllustration = (
  loader: TIllustrationLoader,
): TIllustrationComponent => dynamic(
  () => loader().then((module) => module.default),
);
